/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { Fragment } from "react"
import { CartProvider, useCart } from "frontend/src/utils/useCart"
// import { Cart, ClosedCart } from "frontend/src/components/Cart"
import { Cart } from "frontend/src/components/Cart"
import { Flex } from "./Layout"
import { motion, AnimatePresence } from "framer-motion"
import { Touchable } from "frontend/src/components/Touchable"
import { useBodyScroll } from "frontend/src/utils/useBodyScroll"

function CartPopoverMobile() {
  // const { expanded, numberOfItems } = useCart()
  const { expanded } = useCart()
  return (
    <Flex
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        bg: "transparent",
        zIndex: 2200000000,
        top: expanded ? 0 : "unset",
      }}
    >
      <AnimatePresence>
        {expanded && (
          <motion.div
            key="openCart"
            sx={{
              flex: 1,
              maxHeight: "100%",
              display: "flex",
              flexDirection: "column",
              bg: "white",
            }}
            initial={{ translateY: "100%" }}
            animate={{ translateY: 0 }}
            transition={{ duration: 0.4 }}
            exit={{ translateY: "100%" }}
          >
            <Cart />
          </motion.div>
        ) /* : (
          numberOfItems > 0 && (
            <motion.div
              key="closedCart"
              sx={{ bg: "white", position: "fixed", bottom: 0, width: "100%" }}
              initial={{ translateY: "100%" }}
              animate={{ translateY: 0 }}
              transition={{ duration: 0.4 }}
              exit={{ opacity: 0 }}
            >
              <ClosedCart key="closedCart" />
            </motion.div>
          )
        )*/}
      </AnimatePresence>
    </Flex>
  )
}

function CartPopoverDesktop() {
  const { expanded, toggle } = useCart()
  useBodyScroll(!expanded)
  return (
    <Fragment>
      <AnimatePresence>
        {expanded && (
          <motion.div
            exit={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            initial={{ opacity: 0 }}
            sx={{ zIndex: 130 }}
          >
            <Touchable
              onClick={toggle}
              key="background"
              feedback="none"
              sx={{
                bg: "almostBlack",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: "100vw",
                height: "100vh",
                position: "fixed",
                zIndex: 140,
              }}
            />
          </motion.div>
        )}
        {expanded && (
          <motion.div
            key="openCart"
            sx={{
              position: "fixed",
              right: 0,
              top: 0,
              bottom: 0,
              width: 480,
              display: "flex",
              flexDirection: "column",
              bg: "white",
              zIndex: 2200000000,
            }}
            initial={{ translateX: "100%" }}
            animate={{ translateX: 0 }}
            transition={{ duration: 0.4 }}
            exit={{ translateX: "100%" }}
          >
            <Cart />
          </motion.div>
        )}
      </AnimatePresence>
    </Fragment>
  )
}

function WithCartRootLayout({ children, ...props }) {
  return (
    <CartProvider {...props}>
      <main sx={{ variant: "container.root" }}>
        {children}
        <div sx={{ display: ["flex", "none"] }}>
          <CartPopoverMobile />
        </div>
        <div sx={{ display: ["none", "flex"] }}>
          <CartPopoverDesktop />
        </div>
      </main>
    </CartProvider>
  )
}

export default WithCartRootLayout
